module.exports = __webpack_public_path__ + "img/2022.f1951a12.svg";